import { render, staticRenderFns } from "./ValuedInventory.vue?vue&type=template&id=6a1ba38f&"
import script from "./ValuedInventory.vue?vue&type=script&lang=js&"
export * from "./ValuedInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports